<ng-container [ngSwitch]="data?.type" *im2mLet="{ firmwares: firmwares$ | async, currentFw: activeFw$ | async } as tempData">
    <h3 mat-dialog-title>{{ translations.titleKey | transloco }}</h3>
    <mat-dialog-content>
        <liebherr-firmware-search *ngIf="data.type === 'force'" [parentControl]="fwCtrl" [routerType]="data.device.routerType?.name"></liebherr-firmware-search>

        <span *ngIf="translations.hintKey" class="hint" [innerHTML]="translations.hintKey | transloco : translations?.params"></span>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="onCancel()">{{ 'CLOSE' | transloco }}</button>
        <button mat-flat-button color="primary" mat-dialog-close [disabled]="data?.type === 'force' ? fwCtrl.invalid || fwCtrl.pristine : false" (click)="onSubmit()">
            {{ (data.type === 'download' ? 'RELEASE' : data.type === 'activate' ? 'INSTALL' : 'SUBMIT') | transloco }}
        </button>
    </mat-dialog-actions>
</ng-container>
